// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32nyA","col":"styles_col__2FOWw","actions":"styles_actions__2Fx2U","conflict":"styles_conflict__3FsQP"};